import React from 'react';
import { ActionButton, Content, Dialog, DialogTrigger, Heading, View, } from '@adobe/react-spectrum';
import { EmptyView } from 'app/views/components/empty';
import { FilePicker } from 'app/views/components/empty/FilePicker';
const AddPickerButton = () => (React.createElement(FilePicker, null, open => (React.createElement(ActionButton, { "data-test-id": "add-slide", isQuiet: true, onPress: open }, "Add Slide"))));
const AddPageDialogButton = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const open = React.useCallback(() => setIsOpen(true), [setIsOpen]);
    const close = React.useCallback(() => setIsOpen(false), [setIsOpen]);
    return (React.createElement(DialogTrigger, { isDismissable: true, isOpen: isOpen },
        React.createElement(ActionButton, { "data-test-id": "add-slide", isQuiet: true, onPress: open }, "Add Slide"),
        React.createElement(Dialog, { onDismiss: close },
            React.createElement(Heading, null, "Add image to create new slide"),
            React.createElement(Content, null,
                React.createElement(View, { paddingTop: "size-200" },
                    React.createElement(EmptyView, { showBorder: false, showSamples: false, onSelect: close }))))));
};
export const AddPageButton = () => configGet('useSimpleNewPagePicker', false) ? (React.createElement(AddPickerButton, null)) : (React.createElement(AddPageDialogButton, null));
